// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__9aQiW","cell":"style_cell__DpX-S","approvalGrid":"style_approvalGrid__pORLo"};